export interface IDocument {
  id?: number;
  name?: string;
  fileContentType?: string;
  file?: any;
}

export const defaultValue: Readonly<IDocument> = {};
